import { z } from 'zod';

// Business name validation schema
const legalNameSchema = z
    .string()
    .min(1, 'Business name is required')
    .min(2, 'Business name must be at least 2 characters')
    .max(100, 'Business name must be less than 100 characters')
    .regex(/^[a-zA-Z0-9\s\-&.,'()#]+$/, 'Business name contains invalid characters');
// Name validation schema
const nameSchema = z
    .string()
    .min(1, 'Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must be less than 50 characters')
    .regex(/^[a-zA-Z0-9\s\-&.,'()#]+$/, 'Name contains invalid characters');

export { legalNameSchema, nameSchema };
//# sourceMappingURL=name.js.map
